export const pill = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2.5,
    px: 2,
    py: 1,
    mb: { xs: 3, md: 4 },
    borderRadius: '999px',
    background: 'rgba(255,255,255,0.06)',
    // Eyedropped from the target mockup (TARGET.png) border pixels.
    border: '1px solid rgb(22, 88, 133)',
};

// Wraps the bar + its abbreviated-count badge so the badge can be
// absolutely positioned relative to the bar, not the whole pill.
export const barWrapper = {
    position: 'relative',
    flexShrink: 0,
    lineHeight: 0,
};

// The "tricolor bar" — tricolorBar.svg (viewBox 42x26) standing in for the
// old per-avatar circle stack; width/height just match its own aspect ratio.
export const bar = {
    width: 42,
    height: 26,
    display: 'block',
};

// Small dark badge overlapping the bar's right edge, showing the abbreviated
// live count (e.g. "+5M") — mirrors the "+31M" badge in the target mockup.
export const badge = {
    position: 'absolute',
    top: '50%',
    right: -10,
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 22,
    height: 22,
    px: '4px',
    borderRadius: '999px',
    background: 'var(--ecal-navy)',
    border: '1.5px solid rgb(22, 88, 133)',
    color: 'var(--ecal-white)',
    fontSize: '0.6rem',
    fontWeight: 700,
};

export const label = {
    color: 'var(--ecal-white)',
    fontSize: { xs: '0.8rem', md: '0.9rem' },
};

export const count = {
    fontWeight: 700,
};

export const skeletonTone = {
    bgcolor: 'rgba(255,255,255,0.12)',
};
